// import { HelpCircle, Info } from 'lucide-react';
import React, { useMemo } from 'react';
import { Tooltip } from './Tooltip';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
  titleType?: 'largeHeader' | 'subHeader' | 'body' | 'fieldTitle';
  tooltipKey?: string;
  trailingIcon?: React.ReactNode;
  labelClassName?: string;
  fullWidth?: boolean;
}

export function Label({
  children,
  className = '',
  titleType,
  trailingIcon,
  tooltipKey,
  labelClassName,
  fullWidth = true,
  ...props
}: LabelProps) {
  const subHeader = 'text-xl font-bold text-primaryColor';
  const largeHeader = 'text-2xl font-bold text-primaryColor';
  const body = 'text-lg font-normal text-primaryColor';
  const fieldTitle = 'text-primaryColor font-normal text-base';

  const getTitleStyle = () => {
    switch (titleType) {
      case 'body':
        return body;
      case 'subHeader':
        return subHeader;
      case 'largeHeader':
        return largeHeader;
      case 'fieldTitle':
        return fieldTitle;
      default:
        return body;
    }
  };

  const containerStyle = useMemo(() => {
    const style = `flex items-center text-primaryColor justify-between ${fullWidth === true ? 'w-full' : ''} ${getTitleStyle()} ${className}`;
    return style;
  }, [fullWidth, titleType, className]);

  return (
    <div className={containerStyle}>
      <div className={`flex flex-row items-start ${labelClassName}`}>
        <label {...props}>{children}</label>
        <span className="m-1">{trailingIcon}</span>
      </div>
      {tooltipKey && <Tooltip tooltipKey={tooltipKey} />}
    </div>
  );
}
